import { motion } from "framer-motion";
import { Gift, Book, Zap, Calendar, Star, Award } from "lucide-react";

const iconMap = { gift: Gift, book: Book, zap: Zap, calendar: Calendar, star: Star, award: Award };

export default function Bonus({ data }) {
  return (
    <section data-testid="bonus-section" className="py-24 lg:py-32 bg-onyx text-alabaster relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-gold blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="overline mb-4 text-gold" data-testid="bonus-overline">{data.overline}</p>
          <h2 data-testid="bonus-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light">
            {data.title}
          </h2>
          <p className="mt-4 text-alabaster/70">{data.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {(data.items || []).map((b, i) => {
            const Icon = iconMap[b.icon] || Gift;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`bonus-item-${i}`}
                className="relative p-8 border border-alabaster/10 hover:border-gold transition-colors"
              >
                <div className="absolute -top-3 left-6 px-3 py-1 text-[10px] tracking-[0.25em] uppercase font-bold bg-gold text-onyx">
                  Bônus 0{i + 1}
                </div>
                <Icon size={32} className="text-gold mb-5" strokeWidth={1.5} />
                <h3 className="font-serif text-2xl mb-3">{b.title}</h3>
                <p className="text-alabaster/70 leading-relaxed mb-4">{b.description}</p>
                {b.value && (
                  <p className="text-xs tracking-[0.2em] uppercase text-gold">
                    Valor: <span className="line-through">{b.value}</span> · Grátis
                  </p>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
